module.exports = __webpack_public_path__ + "img/other_reason.199ccaa3.svg";